import api from './utilPartner';

const controller = 'LimiteEspecial';
const url = process.env.VUE_APP_ROOT_API + controller;
export default Object.assign({}, api.GetCrud(controller, null), {
  ListarHistoricoImportacao: function (dto) {
    return api.Axios.GetParams(`${url}/Importacao/ListarHistorico`, dto);
  },
  Importacao: function (dto) {
    return api.Axios.PostForm(`${url}/Importacao`, dto);
  },
  ListarPendentes: function (dto) {
    return api.Axios.GetParams(`${url}/Pendentes/Listar`, dto);
  },
  AprovarParticipantePendente: function (dto) {
    dto.acao = 0;
    dto.tipo = 0;
    
    return api.Axios.Post(`${url}/Pendentes/AprovarRecusar`, dto);
  },
  ReprovarParticipantePendente: function (dto) {
    dto.acao = 2;
    dto.tipo = 0;

    return api.Axios.Post(`${url}/Pendentes/AprovarRecusar`, dto);
  },
  AprovarPapelPendente: function (dto) {
    dto.acao = 0;
    dto.tipo = 1;

    return api.Axios.Post(`${url}/Pendentes/AprovarRecusar`, dto);
  },
  ReprovarPapelPendente: function (dto) {
    dto.acao = 2;
    dto.tipo = 1;
    
    return api.Axios.Post(`${url}/Pendentes/AprovarRecusar`, dto);
  },
  ObterAlteracaoCadastral: function (dto) {
    return api.Axios.GetParams(`${url}/Pendentes/ObterAlteracaoCadastral`, dto);
  },
  DownloadPlanilhaPadrao: () => {
    return api.Axios.DownloadFile(`${process.env.VUE_APP_ROOT_API}Static/Limite_Especial.csv`);
  },
  ListarRelatorioLimitePorConta: function (dto, config = {}) {
    return api.Axios.GetParams(`${url}/Relatorios/ListarLimitePorConta`, dto, config);
  },
  ListarRelatorioLimiteTotalPorContrato: function (dto, config = {}) {
    return api.Axios.GetParams(`${url}/Relatorios/ListarLimiteTotalPorContrato`, dto, config);
  },
  ListarRelatorioLimiteTotalPorConta: function (dto, config = {}) {
    return api.Axios.GetParams(`${url}/Relatorios/ListarLimiteTotalPorConta`, dto, config);
  },
  ListarRelatorioDetalhamentoContratos: function (dto, config = {}) {
    return api.Axios.GetParams(`${url}/Relatorios/DetalhamentoContratos`, dto, config);
  },
  ListarAcompanhamento: function (dto) {
    return api.Axios.GetParams(`${url}/Acompanhamento/Listar`, dto);
  },
  AcoesContrato: function (dto) {
    return api.Axios.GetParams(`${url}/Acompanhamento/acoes-contrato`, dto);
  },
  ObterLinkTermoAssinado: function (dto) {
    return api.Axios.GetParams(`${url}/Acompanhamento/termo/link-documento-assinado`, dto);
  },
  CancelarContrato: function (dto) {
    return api.Axios.Put(url, 'Acompanhamento/contrato/cancela', dto);
  },
  AtivarContrato: function (dto) {
    return api.Axios.Put(url, 'Acompanhamento/contrato/ativa', dto);
  },
  SuspenderContrato: function (dto) {
    return api.Axios.Put(url, 'Acompanhamento/contrato/suspende', dto);
  }
});
